import {Site as _Site} from '../../../shared-models/public/site';

export class Site extends _Site {
}

export namespace Site {
    export import RestTypes = _Site.RestTypes;
}

